import { Link } from "react-router-dom";

export default function Shipping() {
  return (
    <div className="max-w-[1000px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-3xl mb-16">
        <div className="ie-overline text-brand-accent mb-4">
          Care
        </div>

        <h1 className="font-serif text-5xl md:text-6xl tracking-tight">
          Shipping & Delivery
        </h1>

        <p className="text-text-secondary text-sm leading-7 mt-6">
          Everything you need to know about receiving your INDUS EIRENE order.
        </p>
      </div>

      <div className="space-y-12 text-sm text-text-secondary leading-7">
        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Order Processing
          </h2>
          <p>
            Orders are processed after successful order confirmation. Once
            your order has been prepared for dispatch, it is handed to our
            delivery partner for shipment.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Delivery
          </h2>
          <p>
            Delivery times can vary depending on your location and courier
            serviceability. The estimated delivery information shown during
            checkout is an estimate and may change because of courier delays,
            weather or other circumstances beyond our control.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Shipping Charges
          </h2>
          <p>
            Applicable shipping charges, if any, will be displayed during
            checkout before you place your order.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Tracking
          </h2>
          <p>
            Once tracking information becomes available, you can use our order
            tracking page to follow your shipment.
          </p>

          <Link to="/track" className="ie-btn-ghost inline-flex mt-5">
            Track an order
          </Link>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Delivery Issues
          </h2>
          <p>
            If your package appears delayed, damaged or incorrectly delivered,
            please contact our care team with your order details so that we can
            assist you.
          </p>
        </section>
      </div>
    </div>
  );
}